import '@kaidam/fc-shared/assets/texteditor/shared.css'
import '@kaidam/fc-shared/assets/texteditor/editor.css'
import React, { FC, useEffect, useState, useMemo } from 'react'
import makeStyles from '@mui/styles/makeStyles';

import {
  Editor,
  EditorState,
  convertFromRaw,
  RawDraftContentState,
} from 'draft-js'

import decorator from './decorators'
import EditorContext from './EditorContext'

import {
  ITextEditor_HorizontalAlign,
} from '@kaidam/fc-shared/src/types/texteditor'

import {
  getNumber,
} from '@kaidam/fc-shared/src/utils/number'

import {
  blockClassnameFn,
  getColorStyles,
} from './utils'

interface StyleProps {
  horizontalAlign?: ITextEditor_HorizontalAlign,
  padding?: number,
}

const useStyles = makeStyles(theme => ({
  editor: ({horizontalAlign, padding}: StyleProps) => ({
    width: '100%',
    textAlign: horizontalAlign,
    padding: theme.spacing(getNumber(padding)),
  }),
}))

interface TextRenderProps {
  value: RawDraftContentState | null,
  horizontalAlign?: ITextEditor_HorizontalAlign,
  padding?: number,
}

const TextRender: FC<React.PropsWithChildren<TextRenderProps>> = ({
  value,
  horizontalAlign,
  padding,
}) => {

  const classes = useStyles({
    horizontalAlign,
    padding,
  })

  const [ editorState, setEditorState ] = useState(() =>
    EditorState.createEmpty(),
  )

  const style = useMemo<string>(() => {
    const contentState = editorState.getCurrentContent()
    return getColorStyles(contentState)
  }, [
    editorState,
  ])

  useEffect(() => {
    if(!value) return
    setEditorState(EditorState.createWithContent(convertFromRaw(value), decorator))
  }, [
    value,
  ])

  return (
    <EditorContext.Provider value={{
      focus: () => {},
      disableLinkClicks: true,
    }}>
      <div className={ classes.editor }>
        <style dangerouslySetInnerHTML={{__html: style}} />
        <Editor
          readOnly
          editorState={ editorState }
          blockStyleFn={ blockClassnameFn }
          onChange={ () => {} }
        />
      </div>
    </EditorContext.Provider>
  )
}

export default TextRender